import { SignDocumentsDialog } from "../../SignDocumentsDialog";
import { useAlerts } from "./useAlerts";
import { RenderAlerts } from "./RenderAlerts";
import { useESign } from "./useESign";
import { BillingDetails } from "shared";

type AlertProps = {
  billingDetails: BillingDetails;
};

export function Alerts({ billingDetails }: AlertProps) {
  const { shouldShowDialog, policyName, status, email, send, resend, dismiss } =
    useESign();

  const alerts = useAlerts(billingDetails, send);

  return (
    <>
      <RenderAlerts alerts={alerts} />

      {shouldShowDialog && (
        <SignDocumentsDialog
          policyName={policyName}
          status={status}
          email={email}
          resend={resend}
          onDismiss={dismiss}
        />
      )}
    </>
  );
}
